export default "__VITE_ASSET__BbIPx0RR__"